import { useTenantContext } from '../tenant-context/index.tsx';

export const useFabricProfileDirectoryUrl = (): string => {
	const tenantContext = useTenantContext();

	return (tenantContext && tenantContext.fabricPfDirUrl) || '';
};
